import React from 'react'

const Header = () => {
  return (
    <header className='p-8 bg-[#ffffff] boxshadow'>
        <nav className='flex justify-center'>
            <div className='text-2xl font-semibold text-center'>Text-utils</div>
        </nav>
    </header>
  )
}

export default Header
